import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";
import { getLanguages } from "@redux/selectors/translations";
import api from "services/backendService";
import utils from "utils";
import { Store as notifyStore } from "react-notifications-component";
import { tempOptions, NotifyContent } from "components/Notify";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation("common");
  const languages = useSelector(getLanguages);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const toggle = () => setIsOpen((prev) => !prev);

  const currentCode = i18n.language;

  const handleSelect = async (lang) => {
    const code = lang.lang;
    const fullKey = `${lang.text}_${lang.lang}`;

    if (code === currentCode || isLoading) return;

    if (i18n.hasResourceBundle(code, "common")) {
      i18n.changeLanguage(code);
      localStorage.setItem("tempLanguage", fullKey);
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.getTranslations(fullKey);
      const translations = response.data;
      i18n.addResourceBundle(code, "common", translations, true, true);
      i18n.changeLanguage(code);
      localStorage.setItem("tempLanguage", fullKey);
    } catch (error) {
      utils.debug(error, utils.MSG_TYPE_ERR);
      notifyStore.addNotification({
        ...tempOptions,
        content: NotifyContent("danger", t("sidebar.changesNotApplied")),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dropdown
      className="language-switcher"
      isOpen={isOpen}
      toggle={toggle}
    >
      <DropdownToggle nav className="language-switcher-toggle">
        {isLoading ? (
          <ClipLoader color="#ffffff" size={16} />
        ) : (
          <span className="language-switcher-flag">
            <img src={`/images/flags/${currentCode}.svg`} alt="" style={{ width: 20, height: 15, objectFit: 'cover' }} />
          </span>
        )}
      </DropdownToggle>
      <DropdownMenu end className="language-switcher-menu">
        {languages.map((lang) => {
          const code = lang.lang;
          const isActive = code === currentCode;
          return (
            <DropdownItem
              key={code}
              active={isActive}
              disabled={isLoading}
              onClick={() => handleSelect(lang)}
            >
              <img src={`/images/flags/${code}.svg`} alt="" style={{ width: 20, height: 15, objectFit: 'cover', marginRight: 8 }} />
              {lang.text}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
